export const shouldShowCounterTreatmentBanner = ({
  hasForeignRecovery = false,
  hasDispatchPending = false,
  openOrderCount = 0,
  isCounterOperator = false,
  isServerMode = false,
  isCounterPaymentActive = false,
} = {}) =>
  Boolean(
    !isCounterPaymentActive &&
      isCounterOperator &&
      !isServerMode &&
      (hasForeignRecovery || hasDispatchPending || Number(openOrderCount) > 0),
  );

export const filterConfirmedCounterOrders = (
  openOrders = [],
  confirmedOrderIds = [],
) => {
  const normalizedOrderIds = Array.isArray(confirmedOrderIds)
    ? confirmedOrderIds
    : confirmedOrderIds instanceof Set
      ? Array.from(confirmedOrderIds)
      : [confirmedOrderIds];
  const confirmedIds = new Set(
    normalizedOrderIds
      .map((value) => Number(value))
      .filter((value) => Number.isInteger(value) && value > 0),
  );

  if (confirmedIds.size === 0) return openOrders;

  return (Array.isArray(openOrders) ? openOrders : []).filter(
    (order) => !confirmedIds.has(Number(order?.id)),
  );
};
